
import moment from 'moment'
import i18n from "@/i18n/i18n";

const formatDate = {
    methods: {
        formatDate: function (someObject) {
            if (someObject) {
                if (i18n.locale === 'de') {
                    return moment(String(someObject)).format('DD.MM.YYYY')
                } else {
                    return moment(String(someObject)).format('MM/DD/YYYY')
                }
            }
        }

    }
};

export default formatDate;